(function(location, history) {
/* DOI Original: a small foundation. Individual components own their interactions. */
(() => {
  const preview = new URL(location.href).searchParams.get('preview_theme_id') || document.body.dataset.doiPreviewTheme;
  if (preview) {
    const address = new URL(location.href);
    address.searchParams.set('preview_theme_id', preview);
    history.replaceState(history.state, '', address);
  }
  const preservePreview = (anchor) => {
    if (!preview || !anchor?.href || anchor.hasAttribute('download') || anchor.getAttribute('href')?.startsWith('#')) return;
    const url = new URL(anchor.href, location.origin);
    if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol)) return;
    if (url.pathname.startsWith('/account') || url.pathname.startsWith('/customer_authentication/') || url.pathname.startsWith('/checkout') || url.pathname.startsWith('/apps/')) return;
    url.searchParams.set('preview_theme_id', preview);
    anchor.href = url.href;
  };
  document.addEventListener('click', (event) => preservePreview(event.target.closest('a')), true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!preview || form.method.toLowerCase() !== 'get' || new URL(form.action).origin !== location.origin) return;
    let input = form.querySelector('input[name="preview_theme_id"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'preview_theme_id'; form.append(input); }
    input.value = preview;
  });
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-doi-share]');
    if (!button) return;
    const url = button.dataset.url || location.href;
    try {
      if (navigator.share) await navigator.share({ title: document.title, url });
      else { await navigator.clipboard.writeText(url); button.textContent = button.dataset.copied; }
    } catch (error) { if (error.name !== 'AbortError') button.focus(); }
  });
})();

})(globalThis.DOIEmbeddedContext?.location || globalThis.location, globalThis.DOIEmbeddedContext?.history || globalThis.history);
